import { render } from "./MyMessage.vue?vue&type=template&id=4bfaf5a8&scoped=true"
import script from "./MyMessage.vue?vue&type=script&lang=js"
export * from "./MyMessage.vue?vue&type=script&lang=js"

import "./MyMessage.vue?vue&type=style&index=0&id=4bfaf5a8&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfaf5a8"]])

export default __exports__